import React, { useState } from 'react'
import {
  styled,
  InputLabel,
  FormControl,
  TextareaAutosize as MuiTextareaAutosize,
} from '@mui/material'
import { Controller } from 'react-hook-form'

const StyledTextarea = styled(MuiTextareaAutosize)({
  fontFamily: "'URW Geometric Ext', 'Open Sans', sans-serif",
  width: '100%',
  padding: '2rem 0.75rem',
  borderRadius: '4px',
  border: 'none',
  backgroundColor: '#eff2f8',
  fontSize: '18px',
  fontWeight: '600',
  color: '#002677',
  outline: 'none',
  boxShadow: 'none',
  resize: 'none',
  '&:focus': {
    backgroundColor: '#eef2ff',
    boxShadow: '0px -1px 0px 0px #416bf6 inset',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    outline: 'none',
  },
  '&:focus ~ label': {
    opacity: '0.85',
    transform: ' scale(0.8) translateY(-0.6rem) translateX(0.15rem)',
  },
})

const FloatingLabel = styled(InputLabel)(({ theme }) => ({
  fontFamily: "'URW Geometric Ext', 'Open Sans', sans-serif",
  position: 'absolute',
  top: '0',
  left: '0',
  height: '100%',
  padding: '1rem 0.75rem',
  fontSize: '18px',
  fontWeight: '300',
  color: '#002677',
  transition: 'none',
  transform: 'none',
  pointerEvents: 'none',
  '&.has-value': {
    opacity: '0.85',
    transform: ' scale(0.8) translateY(-0.6rem) translateX(0.15rem)',
  },
}))

const FloatingLabelTextarea = styled(FormControl)({
  position: 'relative',
  width: '100%',
  marginBottom: '16px',
})

export const TextArea = ({ name, label, control, rules, error, onBlur }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        const [hasValue, setHasValue] = useState(!!field.value)

        const handleChange = (event) => {
          setHasValue(event.target.value !== '')
          field.onChange(event)
        }

        return (
          <FloatingLabelTextarea className={hasValue ? 'has-value' : ''}>
            <StyledTextarea
              {...field}
              id={name}
              minRows={3}
              value={field.value || ''}
              onChange={handleChange}
            />
            <FloatingLabel
              htmlFor={name}
              className={hasValue ? 'has-value' : ''}>
              {label}
            </FloatingLabel>
            {error && (
              <span className="field-validation-error error pb-0">
                {error.message}
              </span>
            )}
          </FloatingLabelTextarea>
        )
      }}
    />
  )
}

export default TextArea
